import { FC } from 'react';

// No contact Yet
const ContactPhones: FC = () => {
    return <></>;
};

export default ContactPhones;
